import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { setRiskProfile } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/risk-profile/risk-profile.actions';
import { setSavedAnalysisPlanId } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-analysis-plan-id/saved-analysis-plan-id.actions';
import { setSavedHypotheticalId } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-hypothetical-id/saved-hypothetical-id.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { getCurrentWizardStep, getCurrentWizardStepIndex, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { FolderableModal } from 'FoldersApp/features/select-folderable-modal/folderable-modal.enum';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../../../../../../../folders/static/features/select-folderable-modal/select-folderable-modal.component";
export class CustomPDFReportSelectFolderableModalComponent {
    constructor(store) {
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.activeFolderableModal = null;
        this.showBackButton = false;
        this.mapStateToComponent = (state) => {
            this.showBackButton = getCurrentWizardStepIndex(state) !== 0;
            const wizardStep = getCurrentWizardStep(state);
            this.activeFolderableModal = this.getModalTypeForEvent(wizardStep?.eventName);
        };
        this.storeSubscription = this.store
            .select((state) => state[CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY])
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    back() {
        this.store.dispatch(decrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
    cancel() {
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    selection(item) {
        if (!item || !this.activeFolderableModal)
            return;
        switch (this.activeFolderableModal) {
            case FolderableModal.RISK_PROFILE:
                this.store.dispatch(setRiskProfile({ riskProfile: item }));
                break;
            case FolderableModal.HYPOTHETICAL:
                this.store.dispatch(setSavedHypotheticalId({ savedHypotheticalId: Number(item.id) }));
                break;
            case FolderableModal.ANALYSIS_PLAN:
                this.store.dispatch(setSavedAnalysisPlanId({ savedAnalysisPlanId: Number(item.id) }));
                break;
            default:
        }
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
    getModalTypeForEvent(eventName) {
        switch (eventName) {
            case CustomPDFReportModalEventName.SHOW_SELECT_RISK_PROFILE_MODAL:
                return FolderableModal.RISK_PROFILE;
            case CustomPDFReportModalEventName.SHOW_SELECT_SAVED_HYPOTHETICAL_MODAL:
                return FolderableModal.HYPOTHETICAL;
            case CustomPDFReportModalEventName.SHOW_SELECT_INTERACTIVE_ANALYSIS_MODAL:
                return FolderableModal.ANALYSIS_PLAN;
            default:
                return null;
        }
    }
}
CustomPDFReportSelectFolderableModalComponent.ɵfac = function CustomPDFReportSelectFolderableModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomPDFReportSelectFolderableModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
CustomPDFReportSelectFolderableModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomPDFReportSelectFolderableModalComponent, selectors: [["ycn-custom-pdf-report-select-folderable-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 1, vars: 2, consts: [[3, "backHandler", "cancelHandler", "selectionHandler", "activeFolderableModal", "showBackButton"]], template: function CustomPDFReportSelectFolderableModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-select-folderable-modal", 0);
        i0.ɵɵlistener("backHandler", function CustomPDFReportSelectFolderableModalComponent_Template_ycn_select_folderable_modal_backHandler_0_listener() { return ctx.back(); })("cancelHandler", function CustomPDFReportSelectFolderableModalComponent_Template_ycn_select_folderable_modal_cancelHandler_0_listener() { return ctx.cancel(); })("selectionHandler", function CustomPDFReportSelectFolderableModalComponent_Template_ycn_select_folderable_modal_selectionHandler_0_listener($event) { return ctx.selection($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("activeFolderableModal", ctx.activeFolderableModal)("showBackButton", ctx.showBackButton);
    } }, dependencies: [i2.SelectFolderableModalComponent], encapsulation: 2 });
